import styled from '@emotion/styled';
import { AppBar as AppBarMui } from '@mui/material';
import { NavLink } from 'react-router-dom/cjs/react-router-dom';

export const AppBar = styled(AppBarMui)`
  .content {
    display: flex;
    padding: 0 16px;
  }
`;

export const SubMenuWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .subMenu {
    transition: all 0.5s ease-in-out;
    max-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
    border-left: 1px solid #e4e4e4;
    gap: 20px 0;
  }

  .menuLinkHover {
    border-bottom: 2px solid white;
  }

  &:last-child {
    .subMenu {
      border-right: 1px solid #e4e4e4;
    }
  }

  &:has(.active) {
    div > .MuiTypography-root {
      font-weight: 600;
      border-bottom: 2px solid black;
    }
  }

  :hover {
    h4 {
      color: black;
    }
    .menuLinkHover {
      border-bottom: 2px solid black;
      font-weight: 600;
    }
  }
`;

export const NavLinkStyled = styled(NavLink)`
  padding: 0 40px;
  text-decoration: none;
  display: flex;
  gap: 5px;

  &.active {
    .MuiTypography-root {
      font-weight: 600;
    }
  }

  :hover {
    .MuiTypography-root {
      font-weight: 600;
      color: black;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  margin: 0 0 0 50px;

  :hover {
    h4 {
      color: #979797;
    }

    .subMenu {
      max-height: 1000px;
      margin: 0 0 10px 0;
    }
  }
`;

export const MenuWrapper = styled.div`
  height: ${({ height }) => (height || 0) + 'px'};
  min-height: ${({ height }) => (height || 0) + 'px'};
  max-height: ${({ height }) => (height || 0) + 'px'};

  flex: ${({ flex }) => flex};
  display: flex;
  align-items: center;
  margin: 0 0 auto 0;
`;

export const LogosWrapper = styled(MenuWrapper)`
  ${({ theme }) => {
    return `
      column-gap: ${theme.spacing(4)};

      .logo-wrapper {
        line-height: 0;

        &.secondaryCentered img {
          width: 100%;
        }
      }

      :has(.secondaryCentered), :has(.mainCentered) {
        justify-content: center;
      }

      ${theme.breakpoints.up('sm')} {

        &:not(:has(.mainCentered)){
        justify-content: initial;

          .secondaryCentered {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    `;
  }}
`;
